export default __webpack_public_path__ + "static/media/Router.4e7bf5d9.svg";